/**
 * Label card post featured image links with their post titles.
 *
 * Links the `.card-post .wp-block-post-featured-image a` to the corresponding
 * `.card-post-body .wp-block-post-title a` via aria-labelledby so screen reader
 * users hear the post title when navigating to or activating the featured image.
 *
 * @since 1.0.0
 */

/**
 * Add aria-label to featured image links using their post title text.
 */
export function initCardPostImageLabeling() {
	const cardPosts = document.querySelectorAll('.card-post');

	cardPosts.forEach((card) => {
		const imageLink = card.querySelector('.wp-block-post-featured-image a');
		const titleLink = card.querySelector('.card-post-body .wp-block-post-title a');

		if (!imageLink || !titleLink) {
			return;
		}

		const titleText = titleLink.textContent?.trim();

		if (titleText) {
			imageLink.setAttribute('aria-label', titleText);
		}
	});
}
